// src/lib/cache/jobs.js
//
// Per-entity cache wiring for jobs. No deferredField — jobs have no
// server-fabricated number; the only fabricated fields are id, timestamps,
// and created_by, all of which are stable to predict in the optimistic
// placeholder OR overwritten cleanly by reconcile.

import {
  getJobs,
  createJob,
  updateJob,
  deleteJob,
} from '../api/jobs/jobs.js'
import {
  useEntityListQuery,
  useOptimisticListMutation,
  useStandardDeleteMutation,
  defaultCreateReconcile,
  defaultUpdateReconcile,
  unwrapList,
} from './entityCache.js'

const ENTITY = 'jobs'

const buildCreatePlaceholder = (vars, tempId) => {
  const now = new Date().toISOString()
  return {
    status: 'scheduled',
    ...vars,
    id: tempId,
    created_at: now,
    updated_at: now,
  }
}

export const useJobsQuery = () =>
  useEntityListQuery(ENTITY, unwrapList('jobs', getJobs))

export const useCreateJobMutation = () =>
  useOptimisticListMutation(ENTITY, {
    mutationFn: (jobData) => createJob(jobData),
    applyOptimistic: (prev, vars, { tempId }) => [
      buildCreatePlaceholder(vars, tempId),
      ...prev,
    ],
    reconcile: defaultCreateReconcile,
  })

export const useUpdateJobMutation = () =>
  useOptimisticListMutation(ENTITY, {
    mutationFn: ({ id, ...patch }) => updateJob(id, patch),
    applyOptimistic: (prev, vars) =>
      prev.map((row) => (row.id === vars.id ? { ...row, ...vars } : row)),
    reconcile: defaultUpdateReconcile,
  })

export const useDeleteJobMutation = () =>
  useStandardDeleteMutation(ENTITY, deleteJob)
